import React, { useEffect, useState } from "react";
import Header from "./Header";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";

import ServiceModal from "./ServiceModal";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../../api";

function Services(props) {
  const [isServiceModal, setIsServiceModal] = useState(false);
  const [operation, setOperation] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [message, setMessage] = useState("");

  function closeServiceModal() {
    setIsServiceModal(false);
  }

  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const ServicesPageLoaded = async () => {
      try {
        if (adminDetails.email === "" || adminDetails.password === "") {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/adminservices/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    ServicesPageLoaded();
  }, [Navigate, adminDetails.email, adminDetails.password]);

  function deleteService(id) {
    fetch(`${apiURL}/deleteservice/${id}`, {
      method: "GET",
    })
      .then((message) => {
        const messageData = message.json();
        if (messageData) {
          setMessage("The Service has been successfully Deleted");
          setTimeout(() => {
            setMessage("");
          }, 2000);
        } else {
          setMessage("Something Went Wrong");
          setTimeout(() => {
            setMessage("");
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
        setMessage("Server Error");
        setTimeout(() => {
          setMessage("");
        }, 2000);
      });
  }

  return (
    <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
      {isServiceModal && (
        <ServiceModal
          closeServiceModal={closeServiceModal}
          operation={operation}
          serviceId={serviceId}
        />
      )}
      {message ? (
        <div className="bg-secondary w-full text-center font-semibold p-2 text-white">
          {message}
        </div>
      ) : null}
      <Header enableDarkMode={props.enableDarkMode} />
      <div>
        <div className="flex-col justify-between items-center text-gray-600">
          <button
            onClick={() => {
              setOperation("create");
              setIsServiceModal(true);
            }}
            className="dark:bg-slate-500 dark:text-gray-200 font-semibold text-gray-600 flex justify-center items-center w-[88%] mx-auto px-4 py-2 bg-gray-200 outline-none"
          >
            <MdAdd />
            Add Service
          </button>
          <div className="w-[88%] mx-auto">
            <table className="w-full">
              <thead>
                <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
                  <th className="py-2 px-4 font-semibold text-left">Title</th>
                  <th className="py-2 px-4 font-semibold">Price</th>
                  <th className="py-2 px-4 font-semibold">Category</th>
                  <th className="py-2 px-4 font-semibold">Service</th>
                  <th className="py-2 px-4 font-semibold">Edit</th>
                  <th className="py-2 px-4 font-semibold">Remove</th>
                </tr>
              </thead>
              <tbody className="dark:bg-slate-500 dark:text-white">
                {props.services.map((service) => {
                  const imageArray = new Uint8Array(service.image.data.data);
                  let str = "";
                  for (let i = 0; i < imageArray.length; i++) {
                    str += String.fromCharCode(imageArray[i]);
                  }
                  const base64String = btoa(str);
                  return (
                    <tr className="text-center" key={service._id}>
                      <td className="py-2 px-4 text-left">{service.title}</td>
                      <td className="py-2 px-4">${service.price}</td>
                      <td className="py-2 px-4">{service.category}</td>
                      <td className="flex justify-center items-center">
                        <img
                          className="rounded-full"
                          width="40"
                          src={`data:mimeType;base64,${base64String}`}
                          alt="serviceImage"
                        />
                      </td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => {
                            setIsServiceModal(true);
                            setOperation("update");
                            setServiceId(service._id);
                          }}
                        >
                          <MdEdit />
                        </button>
                      </td>
                      <td className="py-2 px-4">
                        <button onClick={() => deleteService(service._id)}>
                          <MdDelete />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
